import { TextField } from '@mui/material';

interface CommentNotesProps {
  disabled: boolean;
  value: string;
  onChange?: (value: string) => void;
}

const CommentNotes = ({ disabled, value, onChange }: CommentNotesProps) => (
  <TextField
    fullWidth
    multiline
    minRows={2}
    label="Comment"
    value={value}
    disabled={disabled}
    onChange={event => onChange?.(event.target.value)}
    placeholder="Add comment"
  />
);

export default CommentNotes;
